import FlexView from './FlexView';

export default FlexView;
